// Purpose: the two stacked radial gradients from the sign-in mockup.
// Blue from top-right, purple from bottom-left. Token-driven so the
// intensity flips per theme (0.14/0.08 dark, 0.08/0.05 light).

export interface RadialGradientBgProps {
  className?: string;
}

export function RadialGradientBg({ className }: RadialGradientBgProps) {
  return (
    <div
      aria-hidden
      className={['absolute inset-0 pointer-events-none bg-radial-gradients', className ?? ''].join(
        ' '
      )}
    />
  );
}
